'use client'

import CardSelect from '@/app/components/atomic/CardSelect'
import { FAMILY_TYPE_OPTIONS } from './health-form.constants'

interface FamilyTypeCardsProps {
    value: number | null | undefined
    onChange: (value: number) => void
}

export default function FamilyTypeCards({ value, onChange }: FamilyTypeCardsProps) {
    return (
        <CardSelect<number>
            variant="travel"
            layout="tile"
            options={FAMILY_TYPE_OPTIONS}
            value={value}
            onChange={onChange}
            testIdPrefix="select-card"
            containerClassName="grid grid-cols-2 gap-2.5 md:grid-cols-4 md:gap-4"
        />
    )
}
